

<!-- synoptique view -->
<div *ngIf="display">
    <div class="header2" *ngIf="validityData">
        <div class="ctn ctn-left">
            <span>{{header}} :&nbsp;</span>
            <div class="hoverPopInfo ctn ctn-left">
                <div class="" *ngFor="let segment of segmentList; let i=index">
                    <!-- <span> {{segment}}<ng-container *ngIf="i<(segmentList.length-1)">,&nbsp;</ng-container></span> -->
                    <span class="item-sep"><journey [data]="sectors[segment]"></journey></span>

                </div>
                <div class="popInfoSmall">
                  <div *ngFor="let sectorKey of sectors | keys">
                      <div class="pnr-sectors">
                          <sector [sectorItem]="sectors[sectorKey]" [key]="false"></sector>
                      </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="validityData" class="list-intro ">
        <div class="ctn ctn-left ctn-bottom ctn-wrap">
            <span class="item-sep" [class.invalid]="!valid">
                <span *ngIf="valid" class="label">{{Yii.t('wui-shared-js', 'Validité')}}</span>
                <span *ngIf="!valid" class="label ">{{Yii.t('wui-shared-js', 'invalide depuis le')}}</span>
                <strong class="validityValue" [class.ok]="valid">{{validityData.end | dateMoment:dateFormat.momentMedium}}</strong>
            </span>
            <span class="item-sep">
                <span class="label">{{Yii.t('wui-shared-js', 'Types de tarif')}}</span>
                <strong *ngIf="typeFaretype == 'string'">{{faretypeData}}</strong>
                <strong *ngIf="typeFaretype == 'array'">
                    <ng-container *ngFor="let ft of faretypeData; let l = last">
                        {{ft}}<ng-container *ngIf="!l">, </ng-container>
                    </ng-container>
                </strong>
            </span>
        </div>

    </div>

</div>

<!-- details -->
<div class="list-row hoverarea" *ngIf="display" (click)="showDetails = !showDetails">
    <div class="ctn ctn-right-left ctn-bottom">
        <div class="ctn ctn-left ctn-wrap ctn-bottom">

            <div class='item-sep'>
                <span class="tarif-title">{{label}} : </span> <span class="big-price" [innerHTML]="(total | price)"></span>€
            </div>

            <div class='item-sep'>
                <span class="label">{{HT}} </span><strong><span class="" [innerHTML]="(base | price:'EUR')"></span></strong>
            </div>
            <div class='item-sep'>
                <span class="label">{{Taxes}} </span><strong><span class="" [innerHTML]="(tax | price:'EUR')"></span></strong>
            </div>

        </div>

        <div *ngIf="details === 'details'">
            <btn class="hovervisible" type="invisible">
                <span class="icon">
                    <fa-icon [icon]="iconEye" *ngIf="!showDetails"></fa-icon>
                    <fa-icon [icon]="iconEyeSlash" *ngIf="showDetails"></fa-icon>
                </span>
            </btn>
        </div>
    </div>



    <div class="ctn ctn-left ctn-bottom ctn-wrap tarif-detail" *ngIf="details == 'details'" [class.hidden]="!showDetails">


        <table>

            <tr>
                <td></td>
                <th>{{Yii.t('wui-shared-js', 'Base tarifaire')}}</th>
                <th>{{Yii.t('wui-shared-js', 'Limite bagage')}}</th>
            </tr>
            <tr *ngFor="let farebasisItem of farebasisInfos">
                <th class="hoverPopInfo"><journey [data]="sectors[farebasisItem.segment[0]]"></journey>
                    <div class="popInfoSmall">
                          <div class="pnr-sectors">
                              <sector [sectorItem]="sectors[ farebasisItem.segment[0] ]"></sector>
                          </div>
                    </div>
                    </th>
                <td>{{farebasisItem.code | slice:0:1}} ({{farebasisItem.code}})</td>
                <td>
                    <ng-container *ngFor="let segment of luggageInfos.segment">
                        <luggage
                          *ngIf="segment == farebasisItem.segment[0]"
                          [restriction]="luggageInfos.restriction"></luggage>
                    </ng-container>

                </td>
            </tr>

        </table>


    </div>

</div>
